<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="!isMentor ? 'Bimbingan '+titleOutline : 'Validasi ' + titleOutline" @back="back">
            <common-training-header />
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col>
                <strong style="font-size: 25px">Peserta</strong>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-row type="flex" style="margin-bottom: 12px">
                <a-col  style="padding-left: 12px" flex="1 1 200px"></a-col>
                <a-col flex="0 1">
                    <a-button style="float: right;" type="primary" icon="plus" block :loading="processing" :disabled="!hasSelected" @click="showConfirm">SUBMIT APPROVAL</a-button>
                </a-col>
            </a-row>

            <a-table class="pcp-table" :columns="columns" :dataSource="items.attendants" :row-selection="!isAdvisor ? rowSelectionMentor : rowSelectionAdvisor" rowKey="hash" :loading="loading" :pagination="false" bordered>

                <div slot="name" slot-scope="record" style="text-align: left">
                    {{ record.name }}
                </div>

                <div slot="count" slot-scope="record" style="text-align: center;">
                    <strong>{{ record.activities[0].files_count }}</strong>
                </div>

                <div slot="file" slot-scope="record">
                    <a-button type="link" size="small" v-if="record.activities[0].files[0] && record.activities[0].files[0].file_path" @click="download(record.activities[0].files[0].file_path)">
                        <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                    </a-button>
                </div>

                <div slot="file_presentasi" slot-scope="record">
                    <a-button type="link" size="small" v-if="record.activities[0].files[0] && record.activities[0].presentation_file" @click="download(record.activities[0].presentation_file)">
                        <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                    </a-button>
                </div>

                <div slot="file_revisi" slot-scope="record">
                    <a-button type="link" size="small" v-if="record.activities[0].files[0] && record.activities[0].revision_file" @click="download(record.activities[0].revision_file)">
                        <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                    </a-button>
                </div>

                <div slot="upload_at" slot-scope="record">
                    <div v-if="record.activities[0].files[0] && record.activities[0].files[0].created_at">
                        {{ moment(record.activities[0].files[0].created_at).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>

                <div slot="validated_at" slot-scope="record">
                    <div v-if="record.activities[0].files[0] && record.activities[0].files[0].response_time_mentor != null">
                        {{ moment(record.activities[0].files[0].response_time_mentor).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>

                <div slot="approved_at" slot-scope="record">
                    <div v-if="record.activities[0].files[0] && record.activities[0].files[0].response_time != null && record.activities[0].files[0] && record.activities[0].files[0].approved_level == 2">
                        {{ moment(record.activities[0].files[0].response_time).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>

                <div slot="status" slot-scope="record" style="text-align: center;">
                    <div v-if="isAdvisor">
                        <div v-if="record.activities[0].files_count > 0">
                            <a-tag 
                                v-if="record.activities[0].files[0].approved_level == 2" color="green">
                                Sudah Disetujui
                            </a-tag>
                            <a-tag 
                                v-else-if="record.activities[0].files[0].response_time == null && record.activities[0].files[0].approved_level == 1" 
                                color="orange">
                                Proses Review
                            </a-tag>
                            <a-tag 
                                v-else-if="record.activities[0].files[0].approved_level == 0" 
                                color="blue">
                                Proses Review Mentor
                            </a-tag>
                            <a-tag v-else color="red">
                                Belum Disetujui
                            </a-tag>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="record.activities[0].files_count > 0">
                            <a-tag 
                                v-if="record.activities[0].files[0].approved_level == 2" color="green">
                                Sudah Disetujui
                            </a-tag>
                            <a-tag 
                                v-else-if="record.activities[0].files[0].response_time_mentor == null && record.activities[0].files[0].approved_level == 0" 
                                color="orange">
                                Proses Review
                            </a-tag>
                            <a-tag 
                                v-else-if="record.activities[0].files[0].response_time == null && record.activities[0].files[0].approved_level == 1" 
                                color="blue">
                                Proses Review Pembimbing
                            </a-tag>
                            <a-tag v-else color="red">
                                Belum Disetujui
                            </a-tag>
                        </div>
                    </div>
                </div>

                <div slot="history" slot-scope="record" style="text-align: center;">
                    <a-button icon="solution" size="small" @click="revision(record.hash)" />
                </div>

            </a-table>
        </a-card>
    </div>
</template>

<script>
const statuses = {
    STATUS_WAITING: 'Waiting',
    STATUS_PENDING: 'Pending',
    STATUS_APPROVED: 'Approved'
}

const colors = {
    pending: 'orange',
    waiting: 'red',
    approved: 'green'
}

const columns = [
    {
        key: 'name',
        title: 'Nama Peserta',
        align: 'center',
        scopedSlots: {customRender: 'name'},
    }, {
        key: 'count',
        title: 'Jumlah Bimbingan',
        align: 'center',
        scopedSlots: {customRender: 'count'},
    }, {
        key: 'file',
        title: 'File',
        align: 'center',
        scopedSlots: {customRender: 'file'}
    },  {
        key: 'upload_at',
        title: 'Tanggal Upload',
        align: 'center',
        scopedSlots: {customRender: 'upload_at'}
    }, {
        key: 'validated_at',
        title: 'Tanggal Validasi',
        align: 'center',
        scopedSlots: {customRender: 'validated_at'}
    }, {
        key: 'approved_at',
        title: 'Tanggal Approve',
        align: 'center',
        scopedSlots: {customRender: 'approved_at'}
    }, {
        key: 'status',
        title: 'Status',
        align: 'center',
        scopedSlots: { customRender: 'status'}
    }, {
        key: 'history',
        title: 'History',
        align: 'center',
        scopedSlots: {customRender: 'history'}
    }
]

export default {
    props: {
        outline: {
            type: String,
            required: true
        },
        hash: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            columns,
            items: {
                outline: {
                    title: ''
                },
                attendants: []
            },
            loading: false,
            processing: false,
            selectedRowKeys: [],
            ...statuses,
            colors
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        titleOutline() {
            switch(this.outline) {
                case 'project_evaluation':
                    return 'Evaluasi Project'
                case 'proposal':
                    return 'Proposal'
                case 'evaluation':
                    return 'Evaluasi Kinerja'
                default:
                    return this.items.outline.title
            }
        },
        activeModule() {
            return this.$laravel.active_module
        },
        role(){
            return this.$laravel.roles[this.activeModule.module.identifier]
        },
        isAdvisor(){
            return this.role == 'advisor'
        },
        isMentor() {
            return this.role == 'mentor'
        },
        rowSelectionMentor() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    let mapFileId = selectedRows.map((val, key) => {
                        if(val.activities[0].files[0]){
                            return val.activities[0].files[0].id
                        }
                    })

                    this.selectedRowKeys = mapFileId
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: record.activities[0].files_count < 1 ||
                            record.activities[0].files_count > 0 &&
                            (record.activities[0].files[0].approved_level === 2 || (record.activities[0].files[0].approved_level === 1 ||
                                (record.activities[0].files[0].approved_level < 1 && record.activities[0].files[0].response_time_mentor != null))),
                        style: { visibility: record.activities[0].files_count < 1 || record.activities[0].files_count > 0 && record.activities[0].files[0].approved_level >= 1 ? 'hidden' : 'visible' }
                    },
                }),
            }
        },
        rowSelectionAdvisor() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    let mapFileId = selectedRows.map((val, key) => {
                        if(val.activities[0].files[0]){
                            return val.activities[0].files[0].id
                        }
                    })

                    this.selectedRowKeys = mapFileId
                },
                getCheckboxProps: record => ({
                    props: {
                        disabled: record.activities[0].files_count < 1 ||
                            record.activities[0].files_count > 0 &&
                            (record.activities[0].files[0].approved_level < 1 || (record.activities[0].files[0].approved_level === 2 ||
                                (record.activities[0].files[0].approved_level === 1 && record.activities[0].files[0].response_time != null))),
                        style: { visibility: record.activities[0].files_count < 1 || record.activities[0].files_count > 0 && record.activities[0].files[0].approved_level === 2 ? 'hidden' : 'visible' }
                    },
                }),
            }
        },
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
        title(){
            switch(this.outline) {
                case "proposal":
                    return "Proposal"
                case "project_evaluation":
                    return "Evaluasi Project"
                default:
                    return "Makalah"
            }
        }
    },
    methods: {
        getItems() {
            this.loading = true

            let params = this.activeModule.module.identifier == 'paper' ? null : {
                params: {
                    outline: this.outline
                }
            }

            this.$http
                .get(this.routeUri("api.activity.guidance.attendants", { outline: this.hash }), params)
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        getLatestFile(record) {
            return record.activities[0].files[0]
        },
        getRecordStatus(record)
        {
            let file = this.getLatestFile(record)

            if (typeof file === 'undefined')
                return this.STATUS_WAITING

            if (file.is_approved) {
                return this.STATUS_APPROVED
            }

            return this.STATUS_PENDING
        },
        download(url) {
            window.open(window.location.origin + url, '_blank')
        },
        revision(attendant){
            let params = {
                outline: this.outline,
                attendant: attendant,
                hash: this.hash
            }

            if(this.activeModule.module.identifier == 'paper'){
                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.revision') + '?' + this.$qs.stringify(params)
            }else{
                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.' + this.outline + '.revision') + '?' + this.$qs.stringify(params)
            }
        },
        approved(){
            this.processing = true

            let promise

            let data = new FormData()

            data.append('file_ids', this.selectedRowKeys)
            data.append('is_approved', 1)

            promise = this.$http.post(this.routeUri('api.activity-files.approve'), data)

            promise.then(response =>
                this.handleSuccessResponse(response.data)
            ).catch(error =>
                this.handleResponseError(error.response.data)
            ).finally(() => (this.processing = false))
        },
        handleSuccessResponse(data) {
            let successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => location.reload(), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        showConfirm() {
            var msg = 'Anda yakin akan melakukan approve?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.approved()
                },
                onCancel() {},
                class: 'test',
            });
        },
        back() {
            if(this.outline == 'paper'){
                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.summary')
            }else{
                window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.' + this.outline + '.summary')
            }
        },
        approvedByRole(approved_level){
            switch(this.role){
                case "advisor": {
                    return approved_level == 1
                }
                case "mentor": {
                    return approved_level == 2
                }
            }
        }
    }
}
</script>
